export const changed = (newValue, oldValue) => {
  if (newValue === oldValue) {
    return false;
  }
  return true;
};
